/**
 * Yeniden değerlendirme akışının sabitleri.
 *
 * DİKKAT — sonuç metinleri ARŞİVDİR: backend'deki ReAssessmentTexts.cs ile birebir aynı olmalı.
 * Kapanış açıklaması study_task.description'a düz metin olarak yazılıyor ve filtre/istatistik bu
 * metinlerle eşleşerek çalışıyor. Etiket değiştirilecekse önce backend'deki eşleşme listesine
 * eskisi eklenmelidir, aksi halde geçmiş kayıtlar sınıflandırma dışında kalır.
 *
 * Gerekçe listesi sunucudan gelir (StudyTask.GetReAssessmentDefaults); buradaki kopya yalnızca
 * istek başarısız olursa kullanılan yedektir.
 */

export const RE_ASSESSMENT_OUTCOME = {
    CHANGED: 'Rapor değişti',
    UNCHANGED: 'Rapor aynı kaldı',
}

/** Kapatma diyaloğundaki seçenekler. */
export const RE_ASSESSMENT_OUTCOME_OPTIONS = [
    { value: RE_ASSESSMENT_OUTCOME.CHANGED, labelKey: 'Report Changed' },
    { value: RE_ASSESSMENT_OUTCOME.UNCHANGED, labelKey: 'Report Unchanged' },
]

/** Sunucuya ulaşılamazsa kullanılan yedek gerekçe listesi. */
export const RE_ASSESSMENT_REASONS_FALLBACK = [
    'Klinik bulgularla uyumsuzluk',
    'Gözden kaçmış olabilecek bulgu',
    'Yanlış taraf / lokalizasyon',
    'Ölçüm veya sayısal değer hatası',
    'Karşılaştırmalı tetkik değerlendirilmemiş',
    'Sonuç ile bulgular arasında tutarsızlık',
    'Yazım / şablon hatası',
    'Klinisyen veya hasta itirazı',
    'İkinci görüş talebi',
    'Diğer',
]

/** Serbest metin alanını açan gerekçe. */
export const RE_ASSESSMENT_REASON_OTHER = 'Diğer'

/** Liste/filtre sonucu kodları — backend ReAssessmentFilter sabitleriyle aynı. */
export const RE_ASSESSMENT_RESULT = {
    UNKNOWN: 0,
    CHANGED: 1,
    UNCHANGED: 2,
    OPEN: 3,
}

export const reAssessmentResultKey = (outcome) => ({
    [RE_ASSESSMENT_RESULT.CHANGED]: 'Report Changed',
    [RE_ASSESSMENT_RESULT.UNCHANGED]: 'Report Unchanged',
    [RE_ASSESSMENT_RESULT.OPEN]: 'Open',
}[outcome] || 'Unspecified')

/** Rapor ekranındaki süzgeç — backend ReAssessmentFilterEnum ile aynı. */
export const RE_ASSESSMENT_FILTER = {
    CHANGED: 1,
    UNCHANGED: 2,
    ANY: 3,
}
